<template>
    <div>
        <div class="modal-content" v-loading="dataLoading">
            <el-form label-width="0">
                <h3 class="form-item-title" >所选角色</h3>
                <el-form-item >
                    <span class="mr60">角色名称：{{formItem.role_name||'--'}}</span>
                    <span class="mr60">角色类型：{{roleType||'--'}}</span>
                    <span class="mr60">说明：{{formItem.note||'--'}}</span>
                </el-form-item>

                <TitleLine num="1" class="mt10" title="数据权限设置"/>
                <h3 class="form-item-title mt10">媒体账户权限配置</h3>

                <el-form-item>
                    <div v-for="platItem in platConfig" :key="'platCompany'+platItem.id" class="pl20 mb0">
                        <el-checkbox :value="formItem.plat_ids.includes(platItem.id)" :label="platItem.id" :disabled="isView" :key="platItem.id" name="type" style="width: 200px;">
                            {{platItem.name}}
                        </el-checkbox>
                        <el-radio-group v-model="formItem.plat_company[platItem.id]" :disabled="isView||!formItem.plat_ids.includes(platItem.id)">
                            <el-radio v-for="item in platCompanyConfig[platItem.id]" :label="''+item.id" :disabled="item.disabled" :key="item.id">{{item.name}}
                            </el-radio>
                        </el-radio-group>
                    </div>
                </el-form-item>

                <h3 class="form-item-title" >数据日期权限配置</h3>
                <el-form-item class="pl20">
                    <span v-if="data.data_days_type=='2'">分模块配置</span>
                    <span v-else-if="data.data_days_type=='1'&&data.data_days>0">整体配置：最近{{data.data_days}}天</span>
                    <span v-else>整体配置：不限</span>
                </el-form-item>

                <el-tabs v-model="activeSystem" @tab-click="changeActiveSystem">
                    <el-tab-pane v-for="page in systemList" :label="page.label" :name="page.value" :key="page.value">
                    </el-tab-pane>
                </el-tabs>
                <el-form-item  label-width="20px" v-if="activeSystem=='weapp'">
                        <el-checkbox v-model="formItem.allow_mp" true-label="1" false-label="0" :disabled="isView">允许访问小程序
                        </el-checkbox>
                </el-form-item>
                <TitleLine num="2" title="页面与操作权限"/>
                <el-form-item class="pl20">
                    <el-tabs v-model="activePageName">
                        <el-tab-pane v-for="page in operationConfigList" :label="page.display_name" :name="page.name" :key="page.id">
                            <div slot="label">
                                <span @click.stop>
                                     <el-checkbox v-model="page.checked" :disabled="isView" class="pr6" @change="val=>changeCurModule(page,val)" ></el-checkbox>
                                </span>
                                <span :class="[page.checked?'text-color-primary':'']">{{page.display_name}}</span>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                    <p class="tool-bar pl10">
                        <CheckAllBtn :data="activePageModule" :is-view="isView"/>
                    </p>

                    <div class="ml20 mb50" style="min-height: 650px;">
                        <template v-for="module in activePageModule.children||[]">
                            <ModuleTitle
                                v-if="module.children&&module.children.length>0"
                                :module="module"
                                :is-view="isView"
                                :data-days="formItem.data_days_type"
                            >
                                <div class="ml20">
                                    <ModuleContent
                                        v-for="page in module.children"
                                        :module="page"
                                        :is-view="isView"
                                        :table-list="tableList"
                                        :data-days="formItem.data_days_type"
                                        :period-config="periodConfig"
                                        :tag-editable="tagActionIdsEditable"
                                    ></ModuleContent>
                                </div>
                            </ModuleTitle>
                            <ModuleContent
                                v-else
                                :module="module"
                                :is-view="isView"
                                :table-list="tableList"
                                :data-days="formItem.data_days_type"
                                :period-config="periodConfig"
                                :tag-editable="tagActionIdsEditable"
                            ></ModuleContent>
                        </template>
                    </div>
                </el-form-item>
            </el-form>
        </div>

        <div slot="footer" class="dialog-footer tac pt20">
            <el-button type="primary" @click="hideModal">关闭</el-button>
        </div>

    </div>
</template>

<script>
    import API from '@/api/role.js';
    import {platMap} from '@/constant/index.js';
    import ModuleTitle from '../../authorityManagement/components/roleNew/moduleTitle.vue';
    import ModuleContent from '../../authorityManagement/components/roleNew/moduleContent.vue';
    import CheckAllBtn from '../../authorityManagement/components/roleNew/checkAllBtn.vue';
    import TitleLine from '../../authorityManagement/components/roleNew/title-line.vue';


    export default {
        name: "RoleInfoModal",
        props:{
            data:Object,
        },
        components:{
            ModuleTitle,
            ModuleContent,
            CheckAllBtn,
            TitleLine,
        },
        data(){
            return {
                isView:true,
                dataLoading:false,
                formItem:{
                    role_name: '',
                    role_type: '',
                    note: '',
                    plat_ids: [],
                    plat_company: {},
                    data_type: {},
                    dimension_type: {},
                    action_ids: [],
                    role_action: {},
                    sub_data_days:{},
                    special_config:{
                        optional_config_table:'',
                        optional_role:'',
                        tag_action_ids_editable:'',
                        statistical_period:{
                            customize_the_latest_days:'',
                            customize_the_start_date:'',
                        },
                    },
                    data_days_type:'1',      //1-整体配置，2-分模块配置
                    data_days:null,
                    data_days_global:'1',
                    allow_mp: null,
                },
                platCompanyConfig: {},   // 1-全部账户 2-按照客户管理绑定
                platConfig: [],      // 1-OPPO 3-vivo 4-华为 7-mi
                operationConfig: [],     // 页面与操作权限配置
                activePageName: '',
                tagActionIdsEditable:{},      // 单独存放tag标签页面的字段可编辑的值
                roleTypeList:[],
                tableList:[],
                systemList: [
                    {
                        value: 'pc',
                        label: 'PC端系统',
                    },
                    {
                        value: 'weapp',
                        label: '小程序',
                    },
                ],
                activeSystem: 'pc'
            }
        },
        computed:{
            activePageModule(){
                return this.operationConfig.find(item=>item.name==this.activePageName)||{};
            },
            periodConfig(){
                return this.formItem.special_config.statistical_period||{};
            },
            roleType(){
                let item = this.roleTypeList.find(item=>item.id==this.formItem.role_type);
                return item?item.name:'';
            },
            operationConfigList(){
                return this.operationConfig.filter(item=> {
                    if(item.is_mp){
                        return this.activeSystem==='weapp';
                    }
                    return this.activeSystem==='pc';
                });
            },
        },
        mounted(){
            this.getConfig();
            this.getRoleType();
        },
        methods:{
            changeActiveSystem(val) {
                this.activePageName = this.operationConfigList[0].name||'';
            },
            hideModal(){
                this.$emit('close');
            },
            getConfig(){
                this.dataLoading = true;
                API.getAddRoleConfig().then(res => {
                    this.dataLoading = false;
                    let resData = res.data || {};

                    let permConfig = resData.data_config.perm_config||[];

                    permConfig.forEach(item=>{
                        this.platCompanyConfig[item.plat_id] = (item.plat_company_config||[]).sort((a,b)=>b.id-a.id);
                    });
                    this.platConfig = resData.data_config.plat_config || [];
                    this.operationConfig = resData.operation_config || [];
                    this.operationConfig = [...(resData.operation_config || []), ...(resData.mp_operation_config || []).map((v)=> {
                        return {
                            ...v,
                            is_mp: true,
                        }
                    })];
                    this.activePageName = this.operationConfig.map(item=>item.name)[0];
                    this.tableList = resData.optional_config_table||[];

                    /*添加角色时 默认勾选首页并且不可取消*/
                    let homePage = this.operationConfig.find(item=>item.name=='home');
                    if(homePage){
                        this.$set(homePage,'checked',true);
                        this.$set(homePage,'disabled',true);
                        this.$set(homePage,'auto_check',true);
                        this.$set(homePage,'default_check',true);
                    }

                    // this.formItem.plat_ids = this.platConfig.filter(item=>!item.disabled).map(item => ''+item.id);

                    /*先设置默认值*/
                    this.platConfig.forEach(item => {
                        this.$set(this.formItem.plat_company, item.id, '2');    //默认按照账户绑定与授权
                        this.$set(this.formItem.data_type, item.id, []);    //默认选中广告投放数据
                        this.$set(this.formItem.dimension_type, item.id, []);    //
                    });
                    this.setRoleInfo();
                }, (err) => {
                    console.log('getConfig error', err);
                    this.platCompanyConfig = {};
                    this.platConfig = [];
                    this.operationConfig = [];
                    this.dataLoading = false;
                });
            },
            getRoleType() {
                API.getRoleType({
                    id:this.roleId||'',
                }).then(res => {
                    let resData = res.data || {};
                    this.roleTypeList = resData || [];
                }, (err) => {
                    console.log('getRoleType error', err);
                    this.roleTypeList = [];
                });
            },
            setRoleInfo(){
                let resData = this.data || {};
                this.formItem.role_name = resData.role_name;
                this.formItem.role_type = resData.role_type;
                this.formItem.note = resData.note;
                this.formItem.plat_ids = resData.plat_ids.map(item=>item+'');
                this.formItem.data_days_type = resData.data_days_type||'1';      //1-整体配置，2-分模块配置
                this.formItem.allow_mp = resData.allow_mp;
                if(!resData.data_days||resData.data_days==null||resData.data_days==-1){
                    this.formItem.data_days = null;
                    this.formItem.data_days_global = '2';
                }else {
                    this.formItem.data_days = resData.data_days;
                    this.formItem.data_days_global = '1';
                }

                /*
                data_days_type:'1',      //1-整体配置，2-分模块配置
                data_days:null,
                data_days_global:'1',*/     //   1-天数 2-不限

                let platCompany = resData.plat_company|| {};
                let roleAction = resData.role_action || {};
                let subDataDays = resData.sub_data_days || {};
                let specialConfig = resData.special_config||{};
                let optionalRole = specialConfig.optional_role||'';
                let optionalTable = specialConfig.optional_config_table||'';
                let tagActionIdsEditable = specialConfig.tag_action_ids_editable||{};
                let statisticalPeriod = specialConfig.statistical_period||{};

                for (let plat in platCompany) {
                    this.$set(this.formItem.plat_company, '' + plat, platCompany[plat] || '2');
                }
                this.formItem.role_action = roleAction;
                this.formItem.sub_data_days = subDataDays;

                this.formItem.action_ids = resData.action_ids||[];
                this.formItem.special_config.optional_role = optionalRole;

                this.formItem.special_config.optional_config_table = optionalTable;

                if(statisticalPeriod.customize_the_latest_days){
                    this.formItem.special_config.statistical_period.customize_the_latest_days = statisticalPeriod.customize_the_latest_days;
                }
                if(statisticalPeriod.customize_the_start_date){
                    this.formItem.special_config.statistical_period.customize_the_start_date = statisticalPeriod.customize_the_start_date;
                }
                this.tagActionIdsEditable = tagActionIdsEditable;
                this.initConfigData();
            },
            initConfigData() {
                this.operationConfig = this._fmtTreeData(this.operationConfig);
            },
            _fmtTreeData(data) {
                data.forEach((v) => {
                    this.$set(v, 'checked', this.formItem.action_ids.includes(v.id)||v.default_check=='1');
                    if (v.children && v.children.length > 0) {
                        this._fmtTreeData(v.children)
                    }

                    /* 页面节点 */
                    if (v.type == '1') {
                        if (v.func && v.func.length > 0) {
                            this._fmtTreeData(v.func)
                        }
                        if (v.fields && v.fields.length > 0) {
                            this._fmtTreeData(v.fields)
                        }
                        if (v.dimension && v.dimension.length > 0) {
                            this._fmtTreeData(v.dimension)
                        }
                        if(v.special_func&&v.special_func.length>0){
                            let specialFuncArr = v.special_func||[];
                            if(specialFuncArr.findIndex(item=>item.name=='optional_role')!='-1'){
                                let formOptionalRole = this.formItem.special_config.optional_role;
                                this.$set(v, 'optional_role_val', formOptionalRole.length>0?formOptionalRole.split(','):[]);
                            }

                            if(specialFuncArr.findIndex(item=>item.name=='optional_config_table')!='-1'){
                                let formOptionalRole = this.formItem.special_config.optional_config_table;
                                this.$set(v, 'optional_config_table_val', formOptionalRole.length>0?formOptionalRole.split(','):[]);
                            }
                        }
                        if(v.statistical_period&&v.statistical_period.length>0){
                            this._fmtTreeData(v.statistical_period);
                        }
                        if (v.data_permission && v.data_permission.length > 0) {
                            this._fmtTreeData(v.data_permission)
                        }

                        this.$set(v, 'role_action', this.formItem.role_action[v.id] || '2');
                    }
                     if(['material_query_analysis', 'data_query_analysis'].includes(v.name)){
                        let subDataDays = this.formItem.sub_data_days[v.id];
                        if(this.pageType == 'add'){
                            this.$set(v, 'data_days',  null);
                            this.$set(v, 'data_days_global',  '1');
                        }else if(subDataDays==''||subDataDays==null||subDataDays==-1){
                            this.$set(v, 'data_days',  null);
                            this.$set(v, 'data_days_global',  '2');
                        }else{
                            this.$set(v, 'data_days',  subDataDays);
                            this.$set(v, 'data_days_global',  '1');
                        }
                    }
                });
                return data;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .form-item-title {
        /*color: #17233d;*/
        margin-bottom: 8px;
        /*font-weight: normal;*/
        font-size: 12px;
    }
    .mb0{
        margin-bottom: 0!important;
    }

    .modal-content{
        padding: 0 20px;
        max-height: 360px;
        overflow-y: auto;

        ::v-deep .el-form-item__label{
            font-weight: bold;
        }
        ::v-deep .el-form-item__content{
            font-size: 12px;
        }


    }
</style>
